<template>
  <a @click="clicked" class="button">
    Vertrag ablösen
  </a>
</template>

<script setup>
import { computed } from 'vue';
import { useRemoveResource } from '@/client/actions';

const props = defineProps({id: String});
const emits = defineEmits(['success']);

const parent = computed(() => props.id);
const target = computed(() => '/api/podcasts/' + parent.value + '/contract');

const { remove, removing } = useRemoveResource(target);

const success = () => emits('success');
const clicked = () => remove(success);
</script>

<style scoped>
.button
{
  @apply block w-full px-3 py-2;
  @apply text-sm font-semibold text-white text-center;
  @apply rounded-md bg-teal-600 shadow-sm hover:bg-teal-500;
  @apply focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600;
  @apply cursor-pointer;
};
</style>
